import { render, staticRenderFns } from "./ModalMarketingInputAmount.vue?vue&type=template&id=8f42b4c0&scoped=true"
import script from "./ModalMarketingInputAmount.vue?vue&type=script&lang=js"
export * from "./ModalMarketingInputAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f42b4c0",
  null
  
)

export default component.exports